// import React from 'react';

const Auxilliary = props => props.children;

export default Auxilliary;